import React from 'react';
import { injectIntl } from 'react-intl';
import { Grid, Typography } from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

const RemarkSection = props => {
  const { intl } = props;

  return (
    <Grid
      container
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "flex-start"
      }}>
      <Grid>
        <Grid
          container
          spacing={1}
          sx={{
            alignItems: "center",
            justifyContent: "flex-start"
          }}>
          <Grid>
            <WarningRoundedIcon color="error" style={{ verticalAlign: 'middle' }} />
          </Grid>
          <Grid>
            <Typography color="textSecondary">{intl.formatMessage({ id: 'fin-py-remark-1' })}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Grid
          container
          spacing={1}
          sx={{
            alignItems: "center",
            justifyContent: "flex-start"
          }}>
          <Grid>
            <WarningRoundedIcon style={{ color: '#ffa600', verticalAlign: 'middle' }} />
          </Grid>
          <Grid>
            <Typography color="textSecondary">{intl.formatMessage({ id: 'fin-py-remark-2' })}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default injectIntl(RemarkSection);
